import { colors } from "../../styles/colors";

type Props = {
  /** Nothing is rendered for an empty / missing message. */
  message?: string | null | false;
};

/**
 * Inline validation message under a form field.
 *
 * Shared by CustomTextInput, CustomTextSelect and CustomTextDatePicker so a
 * form can say WHICH field blocks a save. Before this, none of those inputs
 * could show an error at all, which is how the vehicle forms ended up with a
 * Save button that silently refused (incident STC, 2026-11).
 *
 * Same colour and indentation as CustomSearch's helperText, so every field of
 * a form reports errors the same way.
 */
export const FieldError: React.FC<Props> = ({ message }) => {
  if (!message) return null;
  return (
    <div
      role="alert"
      style={{
        color: colors.tertiary,
        fontFamily: "Poppins-Regular",
        fontSize: "12px",
        marginTop: "4px",
        paddingLeft: "26px",
      }}
    >
      {message}
    </div>
  );
};
